export default __webpack_public_path__ + "static/media/Segoe-UI.45472284.ttf";